import React from "react";
import "./style.css";
const Input = props => (
  <input
    name={props.name}
    placeholder={props.placeholder}
    className="defaultInput"
    value={props.value}
    onChange={props.onChange}
    onKeyPress={props.onKeyPress}
    type={props.type}
  />
);

export default Input;
